<template>
  <div
    class="tab-pane fade"
    id="public_place"
    role="tabpanel"
    aria-labelledby="public_place-tab"
  >
    <div
      id="dashboard"
      class="row w-100 pl-5 justify-content-start"
      :style="{
        //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
        paddingRight: '0px',
        margin: '0px',
        padding: '0px !important',
      }"
    >
      <div class="container-fluid">
        <div>
          <div class="row">
            <div class="col-sm-12 col-md-12 bg-white py-3">
              <form class="row g-3">
                <div class="col-md-3">
                  <label class="form-label">風景區</label>
                  <select class="form-control" v-model="selectScenicAreaId">
                    <option value="-1">請選擇</option>

                    <option
                      v-for="(list, index) in scenicAreaList"
                      :key="index"
                      :value="list.id"
                    >
                      {{ list.name }}
                    </option>
                  </select>
                </div>

                <!-- <div class="col-md-3 ">
                  <label for="inputPassword4" class="form-label">地點種類</label>
                  <select class="form-control" v-model="selectPublicPlaceType">
                  
                    <option value="">全部</option>
                    <option
                      v-for="(list, index) in this.publicPlaceTypeList"
                      :key="index"
                      :value="list.enumType"
                    >
                      {{ list.description }}
                    </option>
                  </select>
                </div> -->
                <div class="col-md-6 d-flex align-items-end ">
                  <button
                    type="button"
                    class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1"
                    @click="queryPublicPlace()"
                  >
                    <i class="fas fa-search"></i> 查詢
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary btn-sm rounded-pill px-3 mx-1"
                    @click="addPublicPlace()"
                  >
                    <i class="fas fa-plus"></i> 新增
                  </button>
                </div>
              </form>

              <hr />
              <div class="row">
                <div class="col-12">
                  <table
                    id="publicPlaceTable"
                    class="w3-table-all table table-hover table-striped"
                  >
                    <thead class="table-dark">
                      <tr>
                        <th scope="col" width="8%">#</th>
                        <th scope="col" width="10%">風景區</th>
                        <!-- <th scope="col" width="12%">地點種類</th> -->
                        <th scope="col">地點名稱</th>
                        <th scope="col">管理</th>
                      </tr>
                    </thead>
                    <tbody class="align-middle">
                      <tr v-for="(item, index) in publicPlaceList" :key="index">
                        <td class="text-center">{{ index + 1 }}</td>
                        <td>{{ item.ScenicAreaName }}</td>
                        <!-- <td>{{ item.operationTypeName }}</td> -->
                        <td>{{ item.name }}</td>
                        <td class="">
                          <button
                            class="btn btn-info p-2 m-1"
                   
                            data-bs-target="#exampleModalCenter"
                            @click="editPublicPlace(item)"
                          >
                            編輯
                          </button>
                          <button
                            class="btn btn-danger m-1 p-2"
                            @click="isdeltePublicPlace(item)"
                          >
                            刪除
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 新增設備Modal -->
      <div
        class="modal fade"
        id="exampleModalCenter"
        tabindex="-1"
        ref="dialogModal"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-dialog-centered modal-xs"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <div class="modal-title h5 m-2" id="exampleModalCenterTitle">
                {{
                  pageMode === Const.DIALOG_MODE.EDIT_DEVICE ? "編輯" : "新增"
                }}設備地點
              </div>
              <button
                type="button "
                class="close btn btn-primary btn-sm"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body h6">
              <form>
                <div class="row">
                  <div class="">
                    <div class="form-group m-3">
                      <label for="exampleFormControlSelect1" disabled>
                        <span class="text-danger">*</span>風景區
                      </label>
                      <select
                        class="form-control"
                        id="exampleFormControlSelect1"
                        v-model="edittingPublicPlaceScenicAreaId"
                      >
                        <option value="-1">請選擇</option>
                        <option
                          v-for="(list, index) in scenicAreaList"
                          :key="index"
                          :value="list.id"
                        >
                          {{ list.name }}
                        </option>
                      </select>
                    </div>
                    <!-- <div class="form-group m-3">
                      <label for="exampleInputPassword1">
                        <span class="text-danger">*</span>地點種類
                      </label>
                      <select
                        class="form-control"
                        v-model="edittingPublicPlaceData.operationType"
                        :disabled="pageMode === Const.DIALOG_MODE.EDIT_DEVICE"
                      >
                        <option value="-1">請選擇</option>
                        <option
                          v-for="(list, index) in publicPlaceTypeList"
                          :key="index"
                          :value="list.enumType"
                        >
                          {{ list.description }}
                        </option>
                      </select>
                    </div> -->

                    <!-- <div class="form-group m-3">
                      <label for="exampleInputPassword1">地點群組</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="edittingPublicPlaceData.groupPosition"
                      />
                    </div> -->

                    <div class="form-group m-3">
                      <label for="exampleInputPassword1"
                        ><span class="text-danger">*</span>設備地點名稱</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model="edittingPublicPlaceName"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
                @click="dismissPP"
              >
                取消
              </button>
              <button type="button" class="btn btn-primary" @click="executePP">
                {{
                  pageMode === Const.DIALOG_MODE.EDIT_DEVICE ? "確認" : "新增"
                }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import CONST from "../../utils/const";
import Utils from "../../utils/utils";

export default {
  data() {
    return {
      Const: CONST,
      selectScenicAreaId: -1,
      selectPublicPlaceType: "",
      edittingPublicPlaceId: "",
      edittingPublicPlaceName: "",
      edittingPublicPlaceScenicAreaId: "",
      publicPlaceTypeList: [],

      publicPlaceData: [],
      publicPlaceList: [],

      edittingPublicPlaceData: {},
      pageMode: CONST.DIALOG_MODE.VIEW,
      table: null,
    };
  },
  computed: {
    ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),
  },
  watch: {
    selectScenicAreaId: {
      handler(newVal) {
        this.getPublicPlaceList();
      },
      immediate: true,
    },
  },
  methods: {
    initTable: function () {
      this.table = $("#publicPlaceTable").DataTable({
        language: {
          url: "/json/dataTableZHTW.json",
        },
      });
    },
    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy();
      }
      setTimeout(() => {
        this.initTable();
      }, 100);
    },
    openModal() {
      $(this.$refs.dialogModal).modal("show");
    },
    closeModal() {
      $(this.$refs.dialogModal).modal("hide");
      $(".modal-backdrop").remove();
    },

    initEditPublicPlaceData() {
      this.edittingPublicPlaceData = {
        scenicAreaId: -1,
        name: "",
        operationType: -1,
        groupPosition: null,
        isDeleted: false,
      };
    },

    async getPublicPlaceList() {
      if (this.selectScenicAreaId < 0) {
        this.selectPublicPlaceId = -1;
        // return [];
      }
      const condition = {};
      condition[CONST.EAST_COAST_PUBLIC_PLACE_KEY.SCENIC_AREA_ID] =
        this.selectScenicAreaId;
      await this.$store.dispatch("publicPlace/getPublicPlace", {
        placeType: "",
      });
      this.publicPlaceData =
        this.$store.getters["publicPlace/getPublicPlaceData"](condition);
    },

    getscenicAreaIdFromName(name) {
      const target = this.scenicAreaList.find((area) => {
        return area.name === name;
      });
      return target ? target.id : "";
    },

    // getpublicPlaceType() {
    //   this.publicPlaceTypeList = CONST.EAST_COAST_PUBLIC_PLACE_TYPE;
    // },

    queryPublicPlace() {
      // let publicPlaceList = [];
      // if (this.selectScenicAreaId < 0) {
      //   alert("請選擇風景區");
      //   return;
      // }

      // if (this.selectPublicPlaceType !== "") {
      //   this.publicPlaceList = this.publicPlaceData.filter(
      //     (item) => item.operationType === this.selectPublicPlaceType
      //   );
      // } else if (this.selectPublicPlaceType === "") {
      //   this.publicPlaceList = this.publicPlaceData;
      // }
      this.publicPlaceList = this.publicPlaceData.filter(
        (item) => item.isDeleted === false
      );
      Utils.setScenicAreaNamebyId(this.publicPlaceList);
      // console.log("publicPlace",this.publicPlaceList);
      // Utils.setPublicPlaceTypebyData(this.publicPlaceList);
      this.updateTable();
    },

    addPublicPlace() {
      this.initEditPublicPlaceData();
   
      this.edittingPublicPlaceName = "";
      this.edittingPublicPlaceScenicAreaId = -1;
      this.pageMode = CONST.DIALOG_MODE.ADD_DEVICE;
      this.openModal();
    },

    async createPublicPlace() {
      // switch (this.edittingPublicPlaceData.operationType) {
      //   //POST時若為停車場或廁所，必填以下欄位
      //   case "parkingArea":
      //     this.edittingPublicPlaceData.compactParkingSpotNumber = 0;
      //     this.edittingPublicPlaceData.fullSizeParkingSpotNumber = 0;
      //     this.edittingPublicPlaceData.motorcycleParkingSpotNumber = 0;
      //     break;

      //   case "toilet":
      //     this.edittingPublicPlaceData.toiletType = "UnKnown";
      //     break;
      // }


      if (
        this.edittingPublicPlaceScenicAreaId > -1 &&
        this.edittingPublicPlaceName !== ""
      ) {
        this.edittingPublicPlaceData.operationType = "other"; //將新增的地點種類固定為 其他

        this.edittingPublicPlaceData.name = this.edittingPublicPlaceName;
        this.edittingPublicPlaceData.scenicAreaId =this.edittingPublicPlaceScenicAreaId;

        const publicPlace = Object.assign({}, this.edittingPublicPlaceData);
        const result = await this.$store.dispatch(
          "publicPlace/postPublicPlace",
          publicPlace
        );
        // console.log("publicPlace",publicPlace);
        if (result.success) {
          this.closeModal();
          await this.getPublicPlaceList();
          this.queryPublicPlace();
        } else {
          alert("新增失敗");
        }
      } else {
        alert("請輸入完整必填欄位");

        return;
      }
    },

    editPublicPlace(item) {

 
      this.edittingPublicPlaceData = item;
      this.edittingPublicPlaceId = item.id;
      this.edittingPublicPlaceName = item.name;
      this.edittingPublicPlaceScenicAreaId = item.scenicAreaId;

      this.pageMode = CONST.DIALOG_MODE.EDIT_DEVICE;

      this.openModal();

    },

    async deletePublicPlace(item) {
      const result = await this.$store.dispatch(
        "publicPlace/deletePublicPlace",
        item.id
      );

      // console.log("re",result)
      if (result.success) {
        await this.getPublicPlaceList();
        this.queryPublicPlace();
      } else if(result.status === 409){
        alert("此地點下尚有設備，無法刪除");
      }
      else {
        alert("刪除失敗");
      }
    },

    async updatePublicPlace() {
      this.edittingPublicPlaceData.name = this.edittingPublicPlaceName;
      this.edittingPublicPlaceData.scenicAreaId =this.edittingPublicPlaceScenicAreaId;

      const result = await this.$store.dispatch(
        "publicPlace/putPublicPlace",
        this.edittingPublicPlaceData
      );

      if (result.success) {
        alert("編輯成功");
        this.closeModal();
      } else {
        alert("編輯失敗");
      }
    },

    async isdeltePublicPlace(item) {
      //若地點下有設備(不管是否停用)皆顯示提示 <= 已改用 API 判斷
          this.deletePublicPlace(item);

    },

    dismissPP() {

      this.closeModal();
      this.initEditPublicPlaceData();
      this.pageMode === CONST.DIALOG_MODE.VIEW;
    },
    executePP() {
      switch (this.pageMode) {
        //編輯設備地點
        case CONST.DIALOG_MODE.EDIT_DEVICE:
          this.updatePublicPlace();


          break;

        //新增設備地點
        case CONST.DIALOG_MODE.ADD_DEVICE:
          this.createPublicPlace();
          // console.log(CONST.DIALOG_MODE.ADD_DEVICE);

          break;
      }
    },
  },
  async mounted() {
    // this.getpublicPlaceType();
    this.updateTable();
  },
};
</script>
